import moment from 'moment';
import {useState} from 'react';

import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';

import Box from '@mui/material/Box';

import '../scheduling/SelectADate.scss';
import CustomInputLabel from './CustomInputLabel';

const handleDatePick = ({setDate, onChange}) => momentObj => {
  setDate(momentObj);
  if (!momentObj) return;
  const dateStr = momentObj.format('MM/DD/yyyy');
  onChange(
    {target: {value: dateStr}},
    dateStr
  );
};

const DateField = props => {
  const [date, setDate] = useState(
    props.defaultValue
    ? moment(props.defaultValue)
    : null
  );
  const [focused, setFocus] = useState(false);
  const {onChange} = props;
  console.log('DATEPROPS.minDate', props.minDate);
  return (
    <>
      {props?.label && <CustomInputLabel required={props?.required || false}>
        {props.label}
      </CustomInputLabel>}
      <Box className='custom-date-picker'>
          <SingleDatePicker
            id={props.id}
            date={date}
            onDateChange={handleDatePick({setDate, onChange})}
            focused={!!focused}
            onFocusChange={({focused}) => setFocus(focused)}
            numberOfMonths={1}
            hideKeyboardShortcutsPanel={true}
            noBorder={true}
            isOutsideRange={props?.isOutsideRange || (() => false)}
            minDate={props?.minDate ? props.minDate : moment().subtract(2, 'years')}
            disabled={props.disabled || false}
          />
      </Box>
    </>
  );
};

export default DateField;